import LegalPage from "./LegalPage";
import { PRIVACY_POLICY } from "./privacyPolicyContent";

const PrivacyPolicy = () => <LegalPage document={PRIVACY_POLICY} />;

export default PrivacyPolicy;
